import { useEpcQtdFlag } from './useEpcQtdFlag';

export interface EvmContratoSnapshot {
  bac: number;
  pv: number;
  ev: number;
  ac: number;
  spi: number | null;
  cpi: number | null;
  eac: number | null;
  etc: number | null;
  vac: number | null;
}

/**
 * F9.2-X · F1 (locked) — EPC-QTD permanentemente OFF na UI.
 *
 * Anteriormente este hook consultava `emp_vw_evm_contrato` para alimentar
 * cards EPC-QTD. Sob source lock, retorna sempre `evmSnapshot = null` e
 * `isEpcQtd = false`. Mantido para compatibilidade com callers existentes.
 *
 * Para KPIs de EVM oficiais use `getContractKpis` em `src/lib/evm/dataAccess.ts`.
 */
export function useEvmContrato(
  _contratoId: string,
  _tipoContratoOperacional?: string,
  _tipoMedicao?: string,
) {
  // Hook locked dispara log único de source lock.
  useEpcQtdFlag();
  return {
    evmSnapshot: null as EvmContratoSnapshot | null,
    isEvmLoading: false,
    isEpcQtd: false as const,
  };
}
